import styled from "styled-components";

import { ICONS } from "../Image";

import { DIGIPOSTHEME } from "theme/digiPosTheme";
import { MEDIA_QUERIES } from "context/media/MediaConstant";

import { VARIANT_TYPES } from "./TextField.constant";

interface StyledInnerContainerProps {
  value?: string;
  error?: string;
  label?: string;
  type?: string;
}

interface StyledTextProps {
  error?: string;
  masked?: boolean;
  isEyeIconOpen?: boolean;
  toolTipInfo?: string;
  variant?: VARIANT_TYPES;
  placeholder?: string;
}

export const StyledTextFieldContainer = styled.div`
  flex: 1;

  @media ${MEDIA_QUERIES.MOBILE} {
    width: 100%;
  }
`;

export const StyledText = styled.input<StyledTextProps>`
  width: 100%;
  height: ${({ variant }) => (variant === "standart" ? `45px` : "0")};

  padding: ${({ variant }) =>
    variant === "standart" ? `15px 15px 15px 10px` : "10px 15px 8px 8px"};

  background-color: ${({ theme }) => theme.colors.primaryAkbankWhite};
  font-family: ${({ type }) => (type === "masked" ? "Password" : "Campton")};
  font-size: ${({ masked }) => (masked ? "12px" : "14px")};
  font-weight: 500;
  ${({ type }) => type === "masked" && `letter-spacing: 2px`};

  border: solid 1px
    ${({ theme, error }) =>
      error
        ? theme.colors.validationError
        : theme.colors.secondaryGrayTertinary};
  box-sizing: border-box;
  outline: none;

  &:focus {
    ${({ theme, error }) =>
      !error && `border: solid 1px ${theme.colors.secondaryGraySecondary}`};
  }

  &:not(:focus) {
    &::placeholder {
      color: transparent;
    }
  }

  &::placeholder {
    color: ${({ theme }) => theme.colors.secondaryGraySecondary};
  }

  @media ${MEDIA_QUERIES.MOBILE} {
    height: 40px;
    margin-left: 0;
    padding: 10px 12px 8px;

    font-size: ${({ masked }) => (masked ? "12px" : "13px")};
  }
`;

export const StyledIconContainer = styled.div<{ toolTipInfo?: string }>`
  display: flex;
  position: absolute;
  right: 6px;
  top: 10px;

  @media ${MEDIA_QUERIES.MOBILE} {
    right: 4px;
  }
`;

export const StyledEyeIconContainer = styled.div<{ toolTipInfo?: string }>`
  display: flex;
  position: absolute;
  top: 4px;
  right: 0px;

  padding: 10px;

  user-select: none;

  cursor: pointer;

  &:active + ${StyledText} {
    font-family: "Campton";
  }

  &:active {
    & > :first-child {
      background-image: url(${ICONS.OPEN_EYE});
    }
  }
`;

export const StyledEyeIcon = styled.div`
  width: 16px;
  height: 16px;

  background-image: url(${ICONS.CLOSE_EYE});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
`;

export const StyledInnerContainer = styled.div<StyledInnerContainerProps>`
  position: relative;
  display: flex;

  & > :nth-last-child(2):focus + :last-child {
    height: 11px;
    ${({ label }) => !!label?.length && "padding-right: 3px;padding-left: 2px;"}

    color: ${DIGIPOSTHEME.colors.primaryBlack};
    font-size: 12px;
    transform: translate(0px, -13px);
    transition: color 200ms cubic-bezier(0, 0, 0.2, 1) 0ms,
      transform 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;
    background-color: white;

    ${({ value, error }) => {
      return (error?.length || value) && `color:#A6A1AD;`;
    }};
  }

  & > :nth-last-child(2) {
    ${({ value }) => !value && `caret-color: transparent;`};
  }

  & > :last-child {
    ${({ value, error, label }) =>
      (!!error?.length || value) &&
      label !== undefined &&
      `
      padding-right: 3px;
      padding-left: 2px;
      height: 11px;
      font-size: 12px;
      transform: translate(0px, -13px);
      background-color: white;
      transition: color 200ms cubic-bezier(0, 0, 0.2, 1) 0ms,
      transform 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;`};
  }
`;

export const StyleImageContainer = styled.div`
  display: flex;
  flex: 0.03;
  align-items: center;

  margin: 0 0 8px 10px;

  cursor: pointer;

  &:hover {
    & > :first-child {
      visibility: visible;
      opacity: 1;
    }
  }
`;

export const StyledOuterContainer = styled.div<{ disabled?: boolean }>`
  width: 100%;

  display: flex;

  ${({ disabled }) => disabled && `opacity: 0.8;`};
`;
